<template>
  <div>
    <div v-if="allQuarantinedSeries.length === 0">
      Please review all images and redact any PHI that is burned in to the pixel data.
    </div>
    <div v-else>
      <div class="text-base-content mt-5 font-bold">Quarantined series</div>
      <div class="text-base-content/60 mt-2 font-light">
        Series that have been quarantined are automatically marked for removal. To keep these
        series, review the images for PHI and redact if needed, then click "Undo remove" in the
        series list.
      </div>
      <ol class="list-outside ml-8 mt-5 list-decimal">
        <li v-for="(series, seriesIndex) in allQuarantinedSeries" @click="selectSeries(series)">
          <QuarantinedSeries :series="series">
            <span @click="selectSeries(series)" class="cursor-pointer">{{
              series.seriesDescription || `Series ${seriesIndex + 1}`
            }}</span>
          </QuarantinedSeries>
          <!-- <div class="btn" @click="selectSeries(series)" v-if="series.uid !== selectedSeries?.uid">
            Review Series
          </div> -->
        </li>
      </ol>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Series from './types/Series';
import QuarantinedSeries from './QuarantinedSeries.vue';
import CaseDef from './types/CaseDef';

const emits = defineEmits(['select-series']);

const props = defineProps<{
  caseDef: CaseDef;
  selectedSeries: Series | null;
}>();

function selectSeries(series: Series) {
  emits('select-series', series);
}

const allQuarantinedSeries = computed(() => {
  let series: Series[] = [];
  for (const study of props.caseDef.studies) {
    const quarantined = study.series.filter((s) => {
      return s.instances.filter((i) => i.quarantine && !i.quarantine.attestNoPHI).length > 0;
    });
    series = series.concat(quarantined);
  }
  return series;
});
</script>

<style scoped>
li > * {
  vertical-align: top;
}
</style>
